import { BpostShippingLabelClient } from '@frontend/bpost/api';
import { Barcode } from '@frontend/bpost/types';
import { EntityType } from '@frontend/common';
import { Form } from '@frontend/components/forms';
import { ActionModal } from '@frontend/components/modal';
import { ErrorHandler } from '@frontend/error-handler';
import { CommonMessage } from '@frontend/lang';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

interface PrinterModalProps {
    id: string;
    onCancel: () => void;
    dispatch: ThunkDispatch<any, any, Action>;
    barcode: Barcode;
}

export const PrintModal = (props: PrinterModalProps) => {
    const [iotId, setIotId] = useState<string | null>(null);
    const [isPrinting, setIsPrinting] = useState<boolean>(false);
    const print = () => {
        if (iotId) {
            setIsPrinting(() => true);
            BpostShippingLabelClient.printShippingLabel(props.barcode.account_id, props.barcode.id, iotId)
                .then(() => {
                    props.onCancel();
                })
                .catch((err) => ErrorHandler.handleError({ error: err }))
                .finally(() => setIsPrinting(() => false));
        }
    };
    return (
        <ActionModal
            cancel={{ onCancel: () => props.onCancel(), label: CommonMessage.BUTTONS.CANCEL }}
            confirm={{
                onConfirm: print,
                disabled: !iotId,
                isLoading: isPrinting,
                label: (
                    <FormattedMessage
                        id='printer-modal.print'
                        defaultMessage='Print'
                    />
                )
            }}
            title={
                <FormattedMessage
                    id='labels.printLabel'
                    defaultMessage='Print label'
                />
            }>
            <p className='text-foreground-secondary text-sm'>
                <FormattedMessage
                    id='printer-modal.select-printer-message'
                    defaultMessage='Please select a printer to continue.'
                />
            </p>
            <Form
                dispatch={props.dispatch}
                type={EntityType.IOT}
                value={{ iot_id: iotId }}
                onChange={(v) => setIotId(v.iot_id)}
                id='print-label-form'
                useStaticId
                show={['iot_id']}
                required={['iot_id']}
                cardBodyClassName=' '
                bodyClassname='w-full'
                label=' '
            />
        </ActionModal>
    );
};
